<template>
    <div>
        <v-view :tableData="tableData"
                :tableProps="tableProps"
                :modalProps="modalProps"
                :columns="columns"
                :routes="routes"
                :initialSort="initialSort"
                :buttonsVisibility="buttonsVisibility"
                :tooltipColumns="tooltipColumns"
                v-model:selectedRows="selectedRows">

            <template #crud="formProps">
                <SynchronizationForm :formProps="formProps"> </SynchronizationForm>
            </template>
            <template #search="searchProps">
                <SynchronizationSearch :searchProps="searchProps"> </SynchronizationSearch>
            </template>
        </v-view>
    </div>
</template>

<script setup>
import { ref } from "vue";
import SynchronizationForm from "./MarketplaceForm.vue";
import SynchronizationSearch from "./MarketplaceSearch.vue";
import { __ } from "@pages/Helper/utils.js";

const props = defineProps({
    tableData: Object,
    tableProps: Object,
    modalProps: Object,
    columns: Object,
    routes: Object,
    tooltipColumns: Object,
    initialSort: Object,
    buttonsVisibility: Object,
});

const selectedRows = ref([]);

//------------------------------------------------------------------------------

</script>

<style lang="scss" scoped></style>
